module.exports = __webpack_public_path__ + "img/request_guide_sp.46bc030.png";